var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"mt-0",attrs:{"color":"rgb(250, 250, 250)"}},[_c('v-card-text',[_c('v-row',{staticClass:"mt-0",attrs:{"justify":"center","dense":""}},[_c('v-col',[_c('h1',[_vm._v("Módulo en desarrollo o mantenimiento. En breve estará disponible")])])],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }